import { curriculumStore } from 'shared/stores/curriculumStore'

export default function useCurriculumView() {
	const { activeGradeMeta, sessionsForActiveGrade } = curriculumStore

	const completedCount = sessionsForActiveGrade.filter(
		session => session.completed,
	).length
	const totalCount = sessionsForActiveGrade.length
	const progressPercent = totalCount
		? Math.round((completedCount / totalCount) * 100)
		: 0

	const handleResourceClick = (session, resourceKey) => {
		curriculumStore.handleResourceClick(session, resourceKey)
	}

	const handleAssignmentClick = session => {
		curriculumStore.handleAssignmentClick(session)
	}

	const handleMarkComplete = async session => {
		const grade = curriculumStore.activeGrade?.grade
		if (!session?.id || grade == null) return
		try {
			await curriculumStore.markSessionComplete({
				grade,
				sessionId: session.id,
			})
		} catch (error) {
			console.error('Failed to mark session complete:', error)
		}
	}

	return {
		activeGradeMeta,
		sessionsForActiveGrade,
		completedCount,
		totalCount,
		progressPercent,
		handleResourceClick,
		handleAssignmentClick,
		handleMarkComplete,
	}
}
